import ReportAuthorButton from "components/ReportDropdown/ReportAuthorButton";
import Heading from "hardcover-ui/components/Heading";
import Avatar from "hardcover-ui/components/Avatar";
import ExpandingText from "components/ui/ExpandingText";
import Icon from "hardcover-ui/components/Icon";
import faExternalLink from "icons/regular/link.svg";
import TextLink from "hardcover-ui/components/TextLink";
import { PageSerializersAuthorsLayout } from "types/serializers";
import AuthorBio from "./AuthorBio";
import Text from "hardcover-ui/components/Text";
import Badge from "hardcover-ui/components/Badge";
import faArrowRight from "icons/solid/arrow-right.svg";
import faFeatherPointed from "icons/solid/feather-pointed.svg";
import { Link } from "@inertiajs/react";

export default function AuthorHeader({
  author,
}: {
  author: PageSerializersAuthorsLayout;
}) {
  return (
    <>
      <div className="flex flex-col md:flex-row gap-4 items-start">
        <div className="flex-none ">
          <Avatar image={author.image} size="2xl" alt={author.name} />
        </div>
        <div className="flex flex-col space-y-2">
          <Heading>
            {author.name}
            {author.alias?.name && <Icon
              icon={faFeatherPointed}
              className="text-secondary-foreground m-1"
            />}
          </Heading>
          <AuthorBio author={author} />
          <ReportAuthorButton author={author} />
        </div>
      </div>

      <div className="mb-4">
        {author.bio?.length > 0 && (
          <div className="my-4">
            <Heading level={2} size="md" className="mb-2">
              Author Bio
            </Heading>
            <ExpandingText text={author.bio} lines={6} />
          </div>
        )}

        {author.links.length > 0 && (
          <p>
            <TextLink
              href={author.links[0].url}
              target="_blank"
              rel="noreferrer"
              underline
            >
              <span>{author.links[0].title}</span>
              <Icon
                icon={faExternalLink}
                size="xs"
                className="fill-gray-400 dark:fill-gray-200 ml-2"
              />
            </TextLink>
          </p>
        )}

        {author.authorAliases && author.authorAliases.length > 0 && (
        <div className="flex gap-2 flex-wrap my-1">
          <Text variant="secondary" as="p">
            Aliases
          </Text>
          {author.authorAliases.map((alias) => (
            <Link
              key={alias.id}
              href={`/authors/${alias.slug}`}
              className="hover:bg-gray-300 hover:dark:bg-gray-700 rounded-lg transition-colors"
            >
              <Badge variant="secondary" className="group">
                {alias.name}{" "}
                <Icon
                  icon={faArrowRight}
                  size="xs"
                  className="group-hover:opacity-50 transition-opacity"
                />
              </Badge>
            </Link>
          ))}
        </div>
        )}

        {author.alias?.name && (
        <div className="flex gap-2 flex-wrap my-1">
          <Text variant="secondary" as="p">
            Pen name of
          </Text>
          <Link
            href={`/authors/${author.alias?.slug}`}
            className="hover:bg-gray-300 hover:dark:bg-gray-700 rounded-lg transition-colors"
          >
          <Badge variant="secondary" className="group">
            {author.alias?.name}{" "}
            <Icon
              icon={faArrowRight}
              size="xs"
              className="group-hover:opacity-50 transition-opacity"
            />{" "}
          </Badge>
          </Link>
        </div>)}
      </div>
    </>
  );
}
